module.exports = __webpack_public_path__ + "img/img_platform_name_b.a436b1f6.png";